import { IAccount } from '../Interfaces/IAccount';

/**
 * Frontend-Sichtbarkeit des "Imitieren"-Buttons. Rein kosmetisch — das Backend
 * setzt dieselben Regeln (Superuser, kein Self/inaktiv/verstorben/Superuser-Ziel)
 * verbindlich durch.
 */
export function canImpersonate(
    account: IAccount | null | undefined,
    currentUserId: number,
    isSuperadmin: boolean,
): boolean {
    if (!isSuperadmin || !account) {
        return false;
    }
    if (account.id === currentUserId) {
        return false;
    }
    if (account.is_active === false) {
        return false;
    }
    if (account.verstorben) {
        return false;
    }
    if (account.is_superuser) {
        return false;
    }
    return true;
}
